import axios, { AxiosError } from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:3000";

export const apiClient = axios.create({
  baseURL: `${BASE_URL}/v1`,
  headers: {
    "Content-Type": "application/json",
  },
});

// リクエストインターセプター: 保存済みトークンをヘッダーに付与
apiClient.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    config.headers["x-api-key"] = token;
  }
  return config;
});

// レスポンスインターセプター: 401 時は自動ログアウト
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("isAdmin");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

/**
 * Axios / fetch エラーをユーザー向けメッセージに変換するユーティリティ。
 * hooks や API 層で catch したエラーをトーストに渡す際に利用する。
 */
export const getApiErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<{ message?: string }>;
    const status = axiosError.response?.status;

    // サーバーが返したメッセージを優先
    const serverMessage = axiosError.response?.data?.message;
    if (serverMessage) return serverMessage;

    if (!axiosError.response) {
      return "サーバーに接続できません。ネットワーク接続を確認してください。";
    }
    if (status === 400) return "入力内容に誤りがあります。";
    if (status === 403) return "この操作を行う権限がありません。";
    if (status === 404) return "リソースが見つかりませんでした。";
    if (status === 409) return "データが競合しています。再度お試しください。";
    if (status != null && status >= 500)
      return "サーバーエラーが発生しました。しばらくしてからお試しください。";
  }
  return "予期しないエラーが発生しました。";
};
